"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _FormattedCurrency = _interopRequireDefault(require("I18n/components/FormattedCurrency"));

var _CurrencyCodes = require("self-service-api/constants/CurrencyCodes");

// Helpful for currencies with large denominations (i.e. COP)
var ABBREVIATE_THRESHOLD = 100000; // We start to abbreviate Japanese Yen at higher threshold
// to avoid seeing 万 (10,000) symbol https://issues.hubspotcentral.com/browse/WBZ-623

var JPY_ABBREVIATE_THRESHOLD = 99999999;
var MAX_FRACTION_DIGITS = 3;

var PriceDisplay = function PriceDisplay(_ref) {
  var className = _ref.className,
      currencyCode = _ref.currencyCode,
      price = _ref.price,
      _ref$dataSelenium = _ref.dataSelenium,
      dataSelenium = _ref$dataSelenium === void 0 ? '' : _ref$dataSelenium;
  var abbreviateThreshold = currencyCode === _CurrencyCodes.JPY ? JPY_ABBREVIATE_THRESHOLD : ABBREVIATE_THRESHOLD;
  return _react.default.createElement("span", {
    className: className,
    "data-selenium-id": dataSelenium
  }, _react.default.createElement(_FormattedCurrency.default, {
    simplifyCurrency: true,
    value: Math.round(price * 100) / 100,
    currencyCode: currencyCode,
    abbreviate: true,
    abbreviateThreshold: abbreviateThreshold,
    maxFractionDigits: MAX_FRACTION_DIGITS,
    "data-jasmine": "jasmine-price-display"
  }));
};

PriceDisplay.propTypes = {
  dataSelenium: _propTypes.default.string,
  className: _propTypes.default.string,
  currencyCode: _propTypes.default.string.isRequired,
  price: _propTypes.default.number
};
var _default = PriceDisplay;
exports.default = _default;
module.exports = exports.default;